import React, { Component } from 'react';

import styles from './style';

export default class About extends Component {
  constructor(props) {
    super(props);
    this.state = { isReadingAbout: false };
  }

  toggleAboutWindow = () => {
    this.setState({ isReadingAbout: !this.state.isReadingAbout });
  }

  render() {
    return (
      <div>
        <button className={styles['button']}
          onClick={this.toggleAboutWindow}
        >
          About
        </button>

        <div id="about"
          className={styles['about']}
          style={{ display: this.state.isReadingAbout ? 'block' : 'none' }}
        >
          <h1>About</h1>
          <p>The following people contributed to this research: Kenneth Bayer,
            Tomo Bessho, Taylor DeMint, Chase Resio, Joshua Snyder, and Robert Woodward.
            <br />
            <br />
            This work was conducted in the Constraint Systems Laboratory and supervised by
            Berthe Y. Choueiry.
            <br />
            <br />
            It was supported by UCARE grants from the University of Nebraska—Lincoln and by
            REU supplements to grants from the National Science Foundation (CAREER Award #0133568,
            No. RI-111795, RI-1619344 ).
          </p>
          <div className={styles['consyst']}>
            <img src="/~minesweeper/version1/minesweeper/images/consystlabs_logo.png"
              alt="Consyst Labs Logo"
              height="60px"
            />
          </div>
          <div className={styles['nsf']}>
            <img src="/~minesweeper/version1/minesweeper/images/nsf_logo.png"
              alt="NSF Logo"
              height="60px"
            />
          </div>
          <div className={styles['unl']}>
            <img src="/~minesweeper/version1/minesweeper/images/unl_logo.png"
              alt="University of Nebraska-Lincoln Logo"
              height="54px"
            />
          </div>
          <div
            className={styles['close']}
          >
            <button className={styles['close_button']}
              onClick={this.toggleAboutWindow}
            >
              Close
            </button>
          </div>
        </div>

        <div id="modal" className={this.state.isReadingAbout ? styles['modal'] : ''} />

      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/general_panel/About.jsx